import React from 'react';
import { BrowserRouter,Switch, Route, Redirect } from 'react-router-dom'
import { connect } from 'react-redux';
import './App.css';

import Header from './components/header/header.component';
import Footer from './components/footer/footer.component';
import HomePage from './pages/homepage/homepage.component';
import Voucher from './components/voucher-form/voucher-form.component';
import SignUp from './components/sign-up/sign-up.component';
import Dashboard from './pages/dashboard/dashboard.component';
import UpdateDelivery from './pages/delivery-update/delivery-update.component';
import Vouchers from './pages/vouchers/vouchers.component';
import UpdateVoucher from './pages/voucher-update/voucher-update.component';

function App() {
  const registerUser = event => {
    event.preventDefault() // don't redirect the page
    // where we'll add our form logic
  }

  return (
      <div>
        
        <BrowserRouter>
        {/* <Header /> */}
        <Switch>
        <Route exact path='/' component={Voucher}></Route>
          {/* <Route exact path='/' component={HomePage}></Route>
          <Route path='/delivery' component={UpdateDelivery}></Route>
          <Route path='/signup' component={SignUp}></Route>
          <Route  path='/home' component={Voucher}></Route>
          <Route  path='/dashboard' component={Dashboard}></Route>
          <Route  path='/vouchers' component={Vouchers}></Route>
          <Route  path='/update-voucher' component={UpdateVoucher}></Route> */}
 
        </Switch>
        <Footer />
        </BrowserRouter>
      </div>
  )
}

export default App;
